import type { DataTypeSelector } from 'hb-builder/utils/dynamicSelectorsHelpers';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';
import type { APP_TYPE } from 'hb-react/types/appType';

export type FieldAttributes =
  | 'displayAttendees'
  | 'displayDate'
  | 'displayDescription'
  | 'displayImage'
  | 'displayLocation'
  | 'displayOnlineEvent'
  | 'displayTags'
  | 'displayTextLink'
  | 'displayTitle';

type FieldsAttributes = {
  [key in FieldAttributes]: boolean;
};

interface QueryAttributes {
  dataType: DataTypeSelector;
  numberOfItems: number;
  categories?: { label: string; value: string }[];
}

interface ButtonAttributes {
  display: boolean;
  newPage: boolean;
  content?: string;
}

export interface EmailListLayoutsDynamicAttributes {
  button: ButtonAttributes;
  fontFamily: string;
  fields: FieldsAttributes;
  query: QueryAttributes;
  singleLine: boolean;
  type: Exclude<LIST_TYPES, LIST_TYPES.TOPICS>;
}

export interface EmailListProps {
  app: APP_TYPE;
  dynamicAttributes?: EmailListLayoutsDynamicAttributes;
  type: Exclude<LIST_TYPES, LIST_TYPES.TOPICS>;
}

export enum LIST_TYPES {
  EVENTS = 'events',
  NEWS = 'news',
  TOPICS = 'topics',
  EMPTY = 'empty',
}

export interface EmailListItemAttributes extends SectionItemAttributes {
  buttonLink?: string;
  dynamicAttributes: EmailListLayoutsDynamicAttributes;
}
